// src/layouts/AuthLayout.jsx
import {useEffect, useState} from 'react';
import logo from '../assets/img/logo.png'; // Adjust path if your logo is elsewhere
import { useLocation } from 'react-router-dom';

const AuthLayout = ({ children, title }) => {
    const location = useLocation(); // Access the location object
    const [successMessage, setSuccessMessage] = useState('');
    
       useEffect(() => {
        // Check if there's a success message in the location state
        if (location.state && location.state.successMessage) {
            setSuccessMessage(location.state.successMessage);

            // Optionally, clear the message from the local state after a few seconds
            const timer = setTimeout(() => {
                setSuccessMessage('');
            }, 5000); // Message disappears after 5 seconds

            return () => clearTimeout(timer); // Cleanup the timer on component unmount or re-render
        }
        // Important: If the location state changes and there's no successMessage,
        // make sure to clear any existing success message.
        if (!location.state || !location.state.successMessage) {
            setSuccessMessage('');
        }
    }, [location.state]); // Re-run this effect whenever location.state changes

    return (
        <div className="flex items-center justify-center min-h-screen admin-header-gradient">
            <div className="w-full max-w-lg p-6 bg-white rounded-lg shadow-xl ">
                <div className="text-center mb-6">
                    <img src={logo} alt="Company Logo" className="mx-auto h-24 w-auto object-contain" />
                    <h1 className="text-3xl font-bold text-center text-gray-900  mt-4">
                        {title}
                    </h1>
                </div>

                 {successMessage && (
                    <div className="p-4 mb-4 text-sm text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400" role="alert">
                        {successMessage}
                    </div>
                )}

                {children} {/* This is where the LoginPage or SignupPage content will be rendered */}

            </div>
        </div>
    );
};

export default AuthLayout;